import { EditIconButton } from '@src/shared/ui/Button';

const StyleSheet = {
  close: {
    height: '20px',
    width: '20px',
    padding: 0,
    '& .MuiSvgIcon-root': {
      width: '15px',
      height: '15px',
    },
  },
};

type SidebarEditButtonProp = {
  onEdit: () => void;
};
export default function SidebarCloseButton({ onEdit }: SidebarEditButtonProp) {
  return <EditIconButton sx={StyleSheet.close} onClick={onEdit} />;
}
